import React, { useState, useEffect } from "react";
import { FaSearch } from "react-icons/fa";

import Sidebar from "./Sidemenu";
import { useNavigate, useLocation } from "react-router-dom";

const Components = () => {
  const navigate = useNavigate();
  const [assetData, setAssetData] = useState([]);

  useEffect(() => {
    const fetchAssetData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/getAllAssetData`
        );

        if (response.ok) {
          const data = await response.json();
          setAssetData(data);
        } else {
          console.error(
            "Failed to fetch asset data:",
            response.status,
            response.statusText
          );
        }
      } catch (error) {
        console.error("Error fetching asset data:", error);
      }
    };

    fetchAssetData();
  }, []);

  const handleNewButtonClick = () => {
    navigate("/assets");
  };

  const handleTitleClick = (assetId, title) => {
    // Assuming the image URL is available in the asset object
    const asset = assetData.find((a) => a.id === assetId);
    const imageMapping = { [title]: asset.imagePreview };

    navigate(`/assetdashboard/${assetId}?title=${title}`, {
      state: { imageMapping },
    });
  };

  return (
    <div className="container-fluid" style={{ display: "flex" }}>
      <Sidebar />
      <div className="segment-container" style={{ width: "100%",height:'100vh',overflowY:'auto' }}>
        <div
          className="d-flex justify-content-end"
          style={{ marginLeft: "30px" }}
        >
            <button
              className="btn btn-primary"
              style={{ height: "45px", width: "65px" }}
              onClick={handleNewButtonClick}
            >
              <span>New</span>
            </button>
        </div>

        {assetData.length > 0 ? (
          <div className="asset-details">
            <table
              className="table table-bordered table-striped"
              style={{ fontSize: "1.2em", width: "100%" }}
            >
              <thead>
                <tr>
                  <th>
                    <input
                      type="checkbox"
                      style={{ width: "15px", height: "15px" }}
                    />
                  </th>
                  <th style={{ cursor: "pointer" }}>Title</th>
                  <th>Category</th>
                  <th>Download Count</th>
                  <th>Date Created</th>
                  <th>Date Modified</th>
                  <th>Created By</th>
                  <th>ID</th>
                </tr>
              </thead>
              <tbody>
                {assetData.map((asset, index) => (
                  <tr
                    key={index}
                    onClick={() => handleTitleClick(asset.id, asset.title)}
                  >
                    <td>
                      <input
                        type="checkbox"
                        style={{ width: "15px", height: "15px" }}
                      />
                    </td>
                    <td style={{ cursor: "pointer" }}>{asset.title}</td>
                    <td>{asset.category}</td>
                    <td>{asset.downloadCount || 0}</td>
                    <td>{new Date().toLocaleString()}</td>
                    <td>{new Date().toLocaleString()}</td>
                    <td>EPICX</td>
                    <td>{index + 1}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p>Loading asset details...</p>
        )}
      </div>
    </div>
  );
};

export default Components;
